exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".border-box{border:1px solid #dbddde;padding:15px 20px;border-radius:3px}.border-box ul{list-style:none;margin:0;padding:0}.pagination-b{margin:0}tr{text-transform:capitalize}.requests-table .custom_tooltip_mobile{display:inline}.details_tooltiptext{width:125px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/app/pages/requests/requests.css
// module id = 1578
// module chunks = 0